export default [
  {
    path: "/monitoring/unavailable-spklu-dc-2",
    name: "monitoring-unavailable-spklu-dc-2",
    component: () => import("../../views/monitoring/unavailable_spklu_dc_v2"),
    meta: {
      title: "Monitoring",
      activeMenu: "Monitoring",
      breadcrumb: [
        {
          text: "Monitoring",
          disabled: true,
        },
        {
          text: "Unavailable SPKLU DC",
          disabled: true,
        },
      ],
    },
  },
  {
    path: "/monitoring/spklu-nonaktif",
    name: "monitoring-spklu-nonaktif",
    component: () => import("../../views/monitoring/spklu_nonaktif"),
    meta: {
      title: "Monitoring",
      activeMenu: "Monitoring",
      breadcrumb: [
        {
          text: "Monitoring",
          disabled: true,
        },
        {
          text: "SPKLU Non Aktif",
          disabled: true,
        },
      ],
    },
  },
  {
    path: "/monitoring/antrian",
    name: "monitoring-spklu-antrian",
    component: () => import("../../views/monitoring/monitoring-antrian"),
    meta: {
      title: "Monitoring",
      activeMenu: "Monitoring",
      breadcrumb: [
        {
          text: "Monitoring",
          disabled: true,
        },
        {
          text: "Antrian",
          disabled: true,
        },
      ],
    },
  },
  {
    path: "/monitoring/pln",
    name: "monitoring-pln",
    component: () => import("../../views/monitoring/revenue_pln"),
    meta: {
      title: "Monitoring",
      activeMenu: "Monitoring",
      breadcrumb: [
        {
          text: "Monitoring",
          disabled: true,
        },
        {
          text: "Monitoring PLN",
          disabled: true,
        },
      ],
    },
  },
  {
    path: "/monitoring/partner",
    name: "monitoring-partner",
    component: () => import("../../views/monitoring/revenue_partner"),
    meta: {
      title: "Monitoring",
      activeMenu: "Monitoring",
      breadcrumb: [
        {
          text: "Monitoring",
          disabled: true,
        },
        {
          text: "Monitoring Mitra",
          disabled: true,
        },
      ],
    },
  },
];
